import { alertsApi, getSelectedCustomerAccountId, greenPathApi } from './api';
import { delimiters } from '../shared/constants';
import { each, selectAll, select } from '../shared/utils/dom';
/*
* Enroll in GreenPath
*/
export default function greenPath() {
  const el = select('[data-vue-app="greenpath"]');
  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      data: {
        // for accessibility in live regions
        isShow: false,
        success: false,
        successUnEnroll: false,
        successUpdate: false,
        isEnrolled: false,
        isEdit: false,
        agree: false,
        enrollPercent: 50,
        paramPercent: "100",
        ldc: "",
        isDisplayAll: true,
      },
      created() {
        Event.$on('A11yDialogConfirm:unenroll-greenpath', () => {
          this.unEnrollGreenPathRider();
        });
      },
      mounted() {
        this.isEnrolled = (this.$el.dataset && this.$el.dataset.isEnroll) ? JSON.parse(this.$el.dataset.isEnroll) : false;
        this.enrollPercent = (this.$el.dataset && this.$el.dataset.isPercent) ? JSON.parse(this.$el.dataset.isPercent) : 50;
        this.isShow = (this.$el.dataset && this.$el.dataset.isEnroll) ? JSON.parse(this.$el.dataset.isEnroll) : false;
        this.ldc = this.$el.dataset.ldc;
        this.isDisplayAll = (this.$el.dataset && this.$el.dataset.isDisplayAll) ? JSON.parse(this.$el.dataset.isDisplayAll) : true;
      },
      computed: {
        enrollText() {
          if (this.isEnrolled) {
            return 'Enrolled';
          }
          return 'Not Enrolled';
        },
      },
      methods: {
        doEditCancel() {
          this.isShow = true;
          this.isEdit = false;
          this.success = false;
          this.successUnEnroll = false;
          this.successUpdate = false;
        },
        doCancel() {
          this.isShow = false;
          this.isEdit = false;
          this.success = false;
          this.successUnEnroll = false;
          this.successUpdate = false;
        },
        showEnroll() {
          if (!this.isShow) {
            this.isShow = true;
            this.success = false;
            this.successUnEnroll = false;
          }
        },
        EditEnrollment() {
          this.isShow = true;
          this.isEdit = true;
          this.success = false;
          this.successUnEnroll = false;
          this.successUpdate = false;
        },
        enrollGreenPathRider() {
          this.accountId = getSelectedCustomerAccountId();
          if (this.enrollPercent.toString() !== "100" && this.ldc === "NI") {
            this.paramPercent = "0".concat(this.enrollPercent.toString());
          } else {
            this.paramPercent = this.enrollPercent.toString();
          }
          greenPathApi.enrollGreenPathRider(this.ldc, this.accountId, "E", this.paramPercent.toString())
            .then(() => {
              this.success = true;
              this.successUnEnroll = false;
              this.successUpdate = false;
              this.isShow = true;
              this.isEnrolled = true;
              this.isEdit = false;
              each(selectAll('.js-greenpath-enrolled'), (statusBubble) => {
                if (statusBubble) {
                  statusBubble.classList.add('status-bubble--on');
                }
              });
              alertsApi.updateGreenPathEnrolled(true, this.enrollPercent);
            }).catch((err) => {
              console.log(err.response.data);
            });
        },
        unEnrollGreenPathRider() {
          this.accountId = getSelectedCustomerAccountId();
          if (this.enrollPercent.toString() !== "100" && this.ldc === "NI") {
            this.paramPercent = "0".concat(this.enrollPercent.toString());
          } else {
            this.paramPercent = this.enrollPercent.toString();
          }
          greenPathApi.enrollGreenPathRider(this.ldc, this.accountId, "U", this.paramPercent.toString())
            .then(() => {
              this.successUnEnroll = true;
              this.successUpdate = false;
              this.success = false
              this.isShow = false;
              this.isEnrolled = false;
              each(selectAll('.js-greenpath-enrolled'), (statusBubble) => {
                if (statusBubble) {
                  statusBubble.classList.remove('status-bubble--on');
                }
              });
              alertsApi.updateGreenPathEnrolled(false, 0);
            }).catch((err) => {
              console.log(err.response.data);
            });
        },
        updateGreenPathRider() {
          this.accountId = getSelectedCustomerAccountId();
          if (this.enrollPercent.toString() !== "100" && this.ldc === "NI") {
            this.paramPercent = "0".concat(this.enrollPercent.toString());
          } else {
            this.paramPercent = this.enrollPercent.toString();
          }
          greenPathApi.enrollGreenPathRider(this.ldc, this.accountId, "C", this.paramPercent.toString())
            .then(() => {
              this.successUpdate = true;
              this.successUnEnroll = false;
              this.success = false;
              this.isShow = true;
              this.isEnrolled = true;
              this.isEdit = false;
              alertsApi.updateGreenPathEnrolled(true, this.enrollPercent);
            }).catch((err) => {
              console.log(err.response.data);
            });
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/greenPath.js